import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Linkedin, Facebook, Instagram } from 'lucide-react';

export default function Footer() {
  return (
    <footer data-testid="footer" className="footer-dark text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Logo & Description */}
          <div className="md:col-span-2">
            <Link to="/" className="inline-block mb-6">
              <span className="text-3xl font-extrabold">
                SELL<span className="text-[#E94560]">&</span>REC
              </span>
            </Link>
            <p className="text-gray-400 mb-6 max-w-md">
              Il partner strategico per il recruiting tecnico e l'intermediazione nel settore EPC e industriale.
            </p>
            <div className="flex space-x-4">
              <a href="https://sm.linkedin.com/company/sellandrec" target="_blank" rel="noopener noreferrer" data-testid="social-linkedin" className="w-10 h-10 flex items-center justify-center bg-white/10 text-white rounded-full hover:bg-[#E94560] transition-colors">
                <Linkedin size={20} />
              </a>
              <a href="https://www.facebook.com/profile.php?id=61579378733599" target="_blank" rel="noopener noreferrer" data-testid="social-facebook" className="w-10 h-10 flex items-center justify-center bg-white/10 text-white rounded-full hover:bg-[#E94560] transition-colors">
                <Facebook size={20} />
              </a>
              <a href="https://www.instagram.com/sellandrec/" target="_blank" rel="noopener noreferrer" data-testid="social-instagram" className="w-10 h-10 flex items-center justify-center bg-white/10 text-white rounded-full hover:bg-[#E94560] transition-colors">
                <Instagram size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-bold text-lg mb-6">Link Rapidi</h4>
            <ul className="space-y-3">
              <li><Link to="/servizi" className="text-gray-400 hover:text-white transition-colors">Servizi</Link></li>
              <li><Link to="/lavora-con-noi" className="text-gray-400 hover:text-white transition-colors">Lavora con noi</Link></li>
              <li><Link to="/chi-siamo" className="text-gray-400 hover:text-white transition-colors">Chi siamo</Link></li>
              <li><Link to="/contatti" className="text-gray-400 hover:text-white transition-colors">Contatti</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-bold text-lg mb-6">Contatti</h4>
            <ul className="space-y-4">
              <li className="flex items-center space-x-3">
                <Mail size={18} className="text-[#E94560]" />
                <span className="text-gray-400">commerciale@sellandmore.it</span>
              </li>
              <li className="flex items-center space-x-3">
                <Phone size={18} className="text-[#E94560]" />
                <span className="text-gray-400">+39 366 415 8246</span>
              </li>
              <li className="flex items-start space-x-3">
                <MapPin size={18} className="text-[#E94560] mt-1" />
                <span className="text-gray-400">Rovereta - Repubblica di San Marino</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-gray-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-500 text-sm">
            © {new Date().getFullYear()} SELL&REC - Un brand di Sell&More Srl. Tutti i diritti riservati.
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0">
            <a href="#" className="text-gray-500 hover:text-gray-400 text-sm">Privacy Policy</a>
            <a href="#" className="text-gray-500 hover:text-gray-400 text-sm">Cookie Policy</a>
            <a href="#" className="text-gray-500 hover:text-gray-400 text-sm">Termini e Condizioni</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
